import { StressAssessmentRole } from '~/types/model/stressAssessment';
import { useGetStressAssessmentSummary } from '~/usecases/useGetStressAssessmentSummary';
import { useGetStressAssessmentUserReportList } from '../../hooks/useGetStressAssessmentUserReportList';
import { StressAssessmentUserReportListPresentation } from '../../presentations';

type PresentationProps = React.ComponentProps<typeof StressAssessmentUserReportListPresentation>;
type Args = {
  userReportList: NonNullable<ReturnType<typeof useGetStressAssessmentUserReportList>['data']>;
  summary: ReturnType<typeof useGetStressAssessmentSummary>['data'];
  role: StressAssessmentRole;
};
type IConvertToPresentationProps = (args: Args) => Pick<PresentationProps, 'users' | 'tabItems'>;

/**
 * ユーザーが退会済みかどうかを判定する。
 * user_id が null の場合、退会済みユーザーとして扱う。
 */
const isUserRemoved = (userId: number | null) => {
  return userId === null;
};

export const convertToPresentationProps: IConvertToPresentationProps = ({
  userReportList,
  summary,
  role,
}) => {
  const answers = userReportList.stress_assessment_results;
  const isImplementer = role === 'implementer';
  const users = answers.map(answer => ({
    id: String(answer.id),
    name: answer.full_name,
    branchName: answer.branch_name ?? '-',
    // implementerのみ高ストレス判定を表示する
    isHighStress: isImplementer && answer.is_high_stress,
    isRowClickable: isImplementer && !isUserRemoved(answer.user_id),
  }));

  const stressAssessmentSummary = summary?.stress_assessment_summary;

  const completedLabel = stressAssessmentSummary
    ? `回答完了（${stressAssessmentSummary.completed_count}名）`
    : '回答完了';

  const pendingLabel = stressAssessmentSummary
    ? `未回答（${stressAssessmentSummary.pending_count}名）`
    : '未回答';

  const interviewRequestedLabel = stressAssessmentSummary
    ? `面談指導希望（${stressAssessmentSummary.interview_requests_count}名）`
    : '面談指導希望';

  const tabItems = [
    { value: 'completed', label: completedLabel } as const,
    { value: 'pending', label: pendingLabel } as const,
    { value: 'interview_requested', label: interviewRequestedLabel } as const,
  ];

  return { users, tabItems };
};
